import React from "react";
import {
  ConditionPreset,
  SaveConditionPresetRequest
} from "@/components/Expressions/conditionPresetTypes";

export interface ConditionPresetsContextValue {
  presets: ConditionPreset[];
  loading: boolean;
  reload: () => Promise<void>;
  create: (req: SaveConditionPresetRequest) => Promise<ConditionPreset | null>;
  update: (
    id: number,
    req: SaveConditionPresetRequest
  ) => Promise<ConditionPreset | null>;
  remove: (id: number) => Promise<boolean>;
}

export const ConditionPresetsContext =
  React.createContext<ConditionPresetsContextValue>({
    presets: [],
    loading: false,
    reload: async () => {},
    create: async () => null,
    update: async () => null,
    remove: async () => false
  });
